import React from 'react'
import AnimateImageTwo from './AnimateImageTwo'
import AnimateTitleTwo from './AnimatedTitleTwo'

const EmbroideryUnit = () => {
    return (
        <section className='section-embroidery-unit section-padding' id='embroidery-unit'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-8'>
                    <div className='section-img-heading'>
                    <div className='animated-image-wrapper'>
                        <AnimateImageTwo/>
                    </div>
                    <div className='section-title'>
                        <AnimateTitleTwo/>
                     </div>
                     </div>
                </div>
                <div className='col-md-4'>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>The heart of India Embroidery Co. lies in our embroidery unit — a vibrant space where artisans handcraft dreams into reality. Naturally lit and well-ventilated, it’s an environment designed for focus and creativity. Materials and base fabrics are organized for easy access, allowing seamless coordination between designers and craftspeople. Every frame that comes alive here is a testament to India’s living legacy of hand embroidery.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default EmbroideryUnit